var _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJ10BotDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 620 120",
    role: "img",
    "aria-label": "J10 Connect",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#2fc4e6",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 48V31a11 11 0 0 1 11-11h29a11 11 0 0 1 11 11v29a11 11 0 0 1-11 11H81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 70v19a11 11 0 0 1-11 11H34a11 11 0 0 1-11-11V60a11 11 0 0 1 11-11h13"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 136,
    y: 82,
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 68,
    fontWeight: 700,
    letterSpacing: -2,
    fill: "#edf7ff"
  }, "J10")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 82,
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 64,
    fontWeight: 400,
    letterSpacing: -2,
    fill: "#edf7ff"
  }, "Connect")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ10BotDark);
export default __webpack_public_path__ + "static/media/j10bot-dark.de62a67c291c1d1267e91ccd1bbccfcd.svg";
export { ForwardRef as ReactComponent };